import { Tag } from "@blueprintjs/core";
import { Popover2InteractionKind, Tooltip2 } from "@blueprintjs/popover2";
import { useSelector } from "react-redux";
import { selectServices } from "controllers/services/action";

interface ModelTypeTagProps {
  modelType: string
  hideTooltip?: boolean;
}

export default function ModelTypeTag(props: ModelTypeTagProps) {
  const { modelType, hideTooltip } = props;
  const services = useSelector(selectServices);
  const currentService = services?.find((service) => service.name === modelType);
  const label = currentService?.label || modelType;
  const tag = <Tag minimal>{label}</Tag>;

  if (hideTooltip || !currentService?.description) {
    return tag;
  }

  return (
    <Tooltip2
      content={currentService.description.replace(/ \(.*\)/g, "")}
      interactionKind={Popover2InteractionKind.HOVER}
      popoverClassName="tooltip-content text-tooltip"
      hoverCloseDelay={200}
      placement="right"
    >
      {tag}
    </Tooltip2>
  );
}
